export default __webpack_public_path__ + "static/media/checked-bordered.e1826fd2.svg";